import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://buccl.com';
const SITE_NAME = '버킷리스트클래스';
const DEFAULT_TITLE = `${SITE_NAME} | 프리다이빙·스쿠버다이빙 강습·투어·커뮤니티`;
const DEFAULT_DESCRIPTION =
    '프리다이빙·스쿠버다이빙 강습과 국내외 다이빙 투어를 예약하고, 다이버 커뮤니티에서 소통하세요.';
const DEFAULT_IMAGE = `${SITE_URL}/images/logo.png`;

/**
 * 페이지별 SEO 메타태그 (react-helmet-async).
 * SPA 특성상 index.html의 기본 메타태그를 라우트별로 덮어써서
 * 검색결과·소셜 공유에서 페이지마다 다른 title/description이 노출되게 한다.
 *
 * @param {string}  [title]       페이지 제목. "제목 | 버킷리스트클래스"로 조합됨. 없으면 기본 타이틀.
 * @param {string}  [description] 페이지 설명. 없으면 기본 설명.
 * @param {string}  [image]       OG/트위터 공유 이미지 절대 URL.
 * @param {string}  [type]        og:type (기본 website, 게시글은 article).
 * @param {object}  [jsonLd]      schema.org 구조화 데이터 객체 (JSON-LD로 직렬화).
 * @param {boolean} [noIndex]     검색 색인 제외 여부 (비공개·개인화 페이지용).
 */
export default function Seo({ title, description, image, type = 'website', jsonLd, noIndex = false }) {
    const { pathname } = useLocation();
    const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const canonicalUrl = `${SITE_URL}${pathname}`;
    const imageUrl = image || DEFAULT_IMAGE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <link rel="canonical" href={canonicalUrl} />
            {noIndex && <meta name="robots" content="noindex, nofollow" />}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={imageUrl} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
            <meta name="twitter:image" content={imageUrl} />
            {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
        </Helmet>
    );
}
